// IDs de estado de pedido usados en lógica de negocio CRM
export const ORDER_STATUS_ID = {
  CONFIRMED: 7, // Enviado / Confirmado
  CANCELLED: 9, // Cancelado
} as const;

// Configuración de colores de estado para CRM
export const statusColorMap: Record<number, { bg: string; text: string }> = {
  1: {
    // Por confirmar
    bg: 'bg-card-border light:bg-badge-bg-status-2',
    text: 'text-badge-status-2',
  },
  2: {
    // Pendiente
    bg: 'bg-card-border light:bg-badge-bg-status-1',
    text: 'text-badge-status-1',
  },
  3: {
    // Por preparar
    bg: 'bg-card-border light:bg-badge-bg-status-3',
    text: 'text-badge-status-3',
  },
  4: {
    // En preparación (picking)
    bg: 'bg-card-border light:bg-bg-warning',
    text: 'text-warning',
  },
  5: {
    // En preparación (packing)
    bg: 'bg-bg-info',
    text: 'text-info',
  },
  6: {
    // Preparado
    bg: 'bg-card-border light:bg-badge-status-4',
    text: 'text-badge-status-4 light:text-badge-bg-status-4',
  },
  7: {
    // Enviado
    bg: 'bg-bg-success',
    text: 'text-success',
  },
  8: {
    // Devuelto
    bg: 'bg-card-border',
    text: '',
  },
  9: {
    // Cancelado
    bg: 'bg-bg-error',
    text: 'text-error',
  },
};

// Función helper para obtener el color de un estado
export const getStatusColor = (statusId: number) => {
  const statusColor = statusColorMap[statusId] || {
    bg: 'bg-card-border',
    text: 'text-text',
  };
  return `${statusColor.bg} ${statusColor.text}`;
};
